module.exports = __webpack_public_path__ + "img/topicFood.2335fc63.svg";